import gql from 'graphql-tag';
import collegeEventLocationFragment from './collegeEventLocationFragment';

const query = gql`
  query collegeEventLocations {
    viewer {
      id
      eventLocations {
        ...CollegeEventLocation
      }
    }
  }
  ${collegeEventLocationFragment}
`;

export default query;
